export const rankingItems = [
  { id: 1, title: '我独自升级', author: 'DUBU(REDICE STUDIO)', category: '韩漫', rank: 1, heat: '987万', tags: ['热血', '奇幻', '逆袭'], desc: '人类最弱兵器踏上成为最强猎人的道路' },
  { id: 2, title: '咒术回战', author: '芥见下下', category: '日漫', rank: 2, heat: '965万', tags: ['战斗', '黑暗', '校园'], desc: '高中生虎杖悠仁吞下宿傩手指后进入咒术世界' },
  { id: 3, title: '斗罗大陆', author: '唐家三少 / 穆逢春', category: '国漫', rank: 3, heat: '942万', tags: ['玄幻', '热血', '成长'], desc: '唐三穿越斗罗大陆，以武魂踏上巅峰之路' },
  { id: 4, title: '全知读者视角', author: 'sing N song / Sleepy-C', category: '韩漫', rank: 4, heat: '918万', tags: ['科幻', '末世', '悬疑'], desc: '唯一读完末日小说的人面对小说化为现实' },
  { id: 5, title: '完美世界', author: '辰东', category: '国漫', rank: 5, heat: '896万', tags: ['仙侠', '热血', '史诗'], desc: '小不点石昊于大荒中崛起，横推九天十地' },
];

export const featureItems = [
  { id: 1, icon: 'ri-shield-check-line', title: '高清画质 流畅阅读', desc: '所有漫画采用高清扫描与专业优化，支持下拉式连续阅读，告别翻页卡顿，享受沉浸式漫画体验。' },
  { id: 2, icon: 'ri-global-line', title: '海量资源 每日更新', desc: '覆盖韩漫、日漫、国漫三大品类，收录数万部热门作品，编辑团队每日精选上新，追更永不停歇。' },
  { id: 3, icon: 'ri-smartphone-line', title: '多端同步 随时随地', desc: '完美适配电脑、平板与手机，阅读进度云端同步，在家用大屏、出门用手机，看漫从未如此自由。' },
];

export const mediaItems = [
  { id: 1, title: '2026夏季新番推荐：这些韩漫值得一追', tag: '新番导视', author: '编辑小星', time: '3天前', views: '12.8万', desc: '从奇幻冒险到都市恋爱，本季韩漫新作亮点频出，编辑部精心挑选了5部必追作品。' },
  { id: 2, title: '国漫崛起之路：从模仿到引领的十年蜕变', tag: '深度观察', author: '漫画评论员', time: '5天前', views: '9.6万', desc: '回顾国漫近十年的发展历程，从制作水准到故事内核，见证中国漫画的华丽转身。' },
  { id: 3, title: '日漫经典IP续作大盘点：情怀与创新的平衡', tag: '专题策划', author: '编辑部', time: '1周前', views: '8.3万', desc: '当经典作品推出续作或重制，如何在致敬原著的同时带来新鲜感？我们来聊聊。' },
];

export const carouselItems = [
  { id: 1, title: '韩漫热血榜', subtitle: '战斗与成长的极致体验', tag: '热血必看', desc: '从《我独自升级》到《全知读者视角》，精选韩国热血漫画巅峰之作，感受系统流、末世流的独特魅力。' },
  { id: 2, title: '日漫恋爱图鉴', subtitle: '甜到心底的青春物语', tag: '恋爱精选', desc: '校园、职场、奇幻设定下的纯爱故事，让你重温心动的感觉，每一页都是青春的味道。' },
  { id: 3, title: '国漫仙侠宇宙', subtitle: '东方玄幻的视觉盛宴', tag: '仙侠合集', desc: '从《斗罗大陆》到《完美世界》，领略东方玄幻世界的恢弘壮丽，见证少年逆天改命的热血征程。' },
  { id: 4, title: '小众精品推荐', subtitle: '发现宝藏的惊喜之旅', tag: '冷门佳作', desc: '错过这些作品太可惜！编辑部私藏小众佳作大公开，风格独特、口碑爆棚，等待有品位的你发掘。' },
];

export const aboutContent = {
  title: '关于星星动漫网',
  desc1: '星星动漫网成立于2018年，是国内领先的免费漫画在线阅读平台。我们致力于为漫画爱好者提供最优质的阅读体验，汇集韩漫、日漫、国漫三大品类，涵盖热血、恋爱、玄幻、悬疑等数十种题材，收录数万部正版授权与优质汉化作品。',
  desc2: '我们坚持每日更新，编辑团队全天候追踪各大漫画平台最新动态，确保热门连载作品第一时间同步上线。同时，我们建立了完善的分类体系与智能推荐系统，让每一位读者都能快速找到自己喜欢的作品。星星动漫网始终相信：好看的漫画，应该被更多人看到。',
};

export const appContent = {
  title: '星星动漫网 APP',
  subtitle: '随时随地 畅快看漫',
  desc: '星星动漫网移动客户端已全面上线，支持iOS与Android双平台。专为手机阅读优化，流畅下拉式浏览，离线下载、夜间模式、阅读记录同步等功能一应俱全。扫描二维码或在应用商店搜索"星星动漫网"即可下载。',
  features: ['下拉式流畅阅读', '离线下载随时看', '夜间模式护眼', '多端进度同步', '个性化推荐'],
};

export const updateItems = [
  { id: 1, date: '2026-07-28', title: '《我独自升级》第201话已更新', tag: '热门连载' },
  { id: 2, date: '2026-07-28', title: '夏季新番《星界之梯》第1话首发上线', tag: '新作首发' },
  { id: 3, date: '2026-07-27', title: '《咒术回战》第272话汉化完成', tag: '汉化更新' },
  { id: 4, date: '2026-07-27', title: '《斗罗大陆》第598话同步更新', tag: '同步连载' },
  { id: 5, date: '2026-07-26', title: '《全知读者视角》第188话已发布', tag: '热门连载' },
  { id: 6, date: '2026-07-26', title: 'APP v4.2.0版本发布：新增夜间模式', tag: '功能更新' },
  { id: 7, date: '2026-07-25', title: '《完美世界》第386话剧情迎来重大转折', tag: '同步连载' },
  { id: 8, date: '2026-07-25', title: '暑期特辑：国漫仙侠专题正式上线', tag: '专题上线' },
  { id: 9, date: '2026-07-24', title: '《我独自升级》动画化决定！官方PV已公开', tag: '行业资讯' },
];

export const commentItems = [
  { id: 1, name: '漫迷小王', avatar: '王', time: '2小时前', content: '星星动漫网真的太好用了！画质清晰，更新速度也快，《我独自升级》每次都是我在这边第一时间看到的。下拉式阅读比翻页舒服太多了，已经推荐给身边所有看漫画的朋友了。', likes: 128 },
  { id: 2, name: '樱花飘落', avatar: '樱', time: '1天前', content: '作为一个看了十几年漫画的老读者，换过很多平台，最后稳定在星星动漫网。分类清晰、资源全，尤其是韩漫这块做得特别好。希望越做越好，会一直支持下去！', likes: 96 },
  { id: 3, name: '二次元少年', avatar: '二', time: '3天前', content: 'APP端的体验真的很棒，晚上看漫开夜间模式眼睛不累，离线下载功能在地铁上太实用了。就是希望能加个评论区，想和大家一起讨论剧情。期待后续更新！', likes: 75 },
];

export const contactContent = {
  title: '联系我们',
  subtitle: '投稿 / 合作 / 意见反馈',
  desc: '如果您有原创漫画作品希望入驻星星动漫网，或是有商务合作意向，欢迎通过以下方式联系我们。同时也欢迎读者朋友们提供宝贵意见，帮助我们做得更好。',
  email: 'contact@xingxingdm.com',
  wechat: '星星动漫网官方',
  qq: '800123456',
};

export const topicItems = [
  { id: 1, name: '我独自升级', heat: '128万', tag: '韩漫顶流' },
  { id: 2, name: '2026夏季新番', heat: '96万', tag: '新番热议' },
  { id: 3, name: '国漫崛起', heat: '85万', tag: '行业趋势' },
  { id: 4, name: '咒术回战结局', heat: '73万', tag: '剧情讨论' },
  { id: 5, name: '韩漫推荐', heat: '68万', tag: '读者分享' },
  { id: 6, name: '斗罗大陆动画', heat: '62万', tag: 'IP联动' },
  { id: 7, name: '系统流漫画', heat: '55万', tag: '流派探讨' },
  { id: 8, name: '漫画APP横评', heat: '48万', tag: '实用对比' },
  { id: 9, name: '冷门佳作挖掘', heat: '42万', tag: '宝藏发现' },
  { id: 10, name: '全知读者视角', heat: '38万', tag: '末世流代表' },
];

export const faqItems = [
  { id: 1, q: '星星动漫网的漫画都是免费的吗？', a: '是的！星星动漫网上所有漫画均可免费在线阅读，无需付费订阅。我们通过广告与品牌合作维持运营，始终坚持为读者提供免费的优质漫画内容。未来如有任何付费计划，会提前公告并确保不影响现有免费内容。' },
  { id: 2, q: '漫画更新频率是怎样的？', a: '热门连载作品通常每周更新1-2话，具体取决于原作方的发布节奏。我们的编辑团队会在官方更新后第一时间进行汉化与上传，韩漫通常在官方发布后24小时内上线，日漫和国漫的同步速度更快。' },
  { id: 3, q: '如何下载漫画到手机离线观看？', a: '下载星星动漫网APP后，在任意漫画详情页点击"下载"按钮即可将章节缓存到本地。支持批量下载、自动清理和下载管理功能。目前离线下载功能仅在移动端APP可用，网页端暂不支持。' },
  { id: 4, q: '可以投稿自己的原创漫画吗？', a: '当然可以！星星动漫网欢迎原创漫画作者入驻。请通过"联系我们"页面提交您的作品样稿与个人简介，我们的内容团队会在3-5个工作日内审核并回复。优质原创作品将获得首页推荐与流量扶持。' },
];

export const indexItems = [
  { id: 1, title: '韩漫精选', icon: 'ri-sparkling-line', desc: '系统流、末世流、重生流等热门韩国漫画一网打尽', count: '5200+部' },
  { id: 2, title: '日漫经典', icon: 'ri-sun-line', desc: '从Jump系到青年漫，经典连载与完结佳作全面覆盖', count: '8600+部' },
  { id: 3, title: '国漫专区', icon: 'ri-building-2-line', desc: '网文改编、原创精品、动态漫画，国漫生态体系完整', count: '3800+部' },
  { id: 4, title: '热血战斗', icon: 'ri-fire-line', desc: '燃到爆炸的战斗场面与逆袭剧情，血脉喷张的阅读体验', count: '2100+部' },
  { id: 5, title: '恋爱甜宠', icon: 'ri-heart-line', desc: '从校园纯爱到都市虐恋，所有心动配方应有尽有', count: '1800+部' },
  { id: 6, title: '悬疑烧脑', icon: 'ri-lightbulb-flash-line', desc: '反转再反转，智商在线的悬疑推理漫画让你欲罢不能', count: '950+部' },
  { id: 7, title: '新作速递', icon: 'ri-rocket-line', desc: '最新上线的漫画作品第一时间在这里呈现，先睹为快', count: '每日更新' },
];

export const cardItems = [
  { id: 1, title: '剑尊归来', tag: '韩漫·武侠', desc: '天下第一剑回归少年时代，以无敌之姿横扫江湖，重写命运。', views: '236万' },
  { id: 2, title: '鬼灭之刃', tag: '日漫·热血', desc: '少年灶门炭治郎为救妹妹踏上斩鬼之旅，感人至深的兄妹羁绊。', views: '218万' },
  { id: 3, title: '一念永恒', tag: '国漫·仙侠', desc: '白小纯以怕死之道走上修仙巅峰，爆笑与热血并存的另类修仙记。', views: '195万' },
  { id: 4, title: 'SSS级猎人', tag: '韩漫·奇幻', desc: '从最低级觉醒者到世界最强，用实力碾压一切质疑与嘲讽。', views: '187万' },
  { id: 5, title: '间谍过家家', tag: '日漫·喜剧', desc: '间谍父亲、杀手母亲、读心女儿，伪装家庭的温馨搞笑日常。', views: '172万' },
  { id: 6, title: '大王饶命', tag: '国漫·都市', desc: '灵气复苏时代，吕树靠毒舌和吐槽在乱世中生存变强的爆笑故事。', views: '158万' },
];